var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('booking',[_c('div',{staticClass:"booking-need-to-upload"},[_c('div',{staticClass:"lists"},_vm._l((_vm.reservations),function(item,index){return _c('booking-box-need-to-upload',{key:index,attrs:{"data":item}})}),1)])])}
var staticRenderFns = []

export { render, staticRenderFns }